import script from "./FinancialPeriodYear.vue?vue&type=script&setup=true&lang=js"
export * from "./FinancialPeriodYear.vue?vue&type=script&setup=true&lang=js"

import "./FinancialPeriodYear.vue?vue&type=style&index=0&id=53c26089&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53c26089"]])

export default __exports__